import {useRecoilValue, useSetRecoilState} from "recoil"
import {Box, Text} from "zmp-ui"
import ImgDefault from "../../images/list-default.png"
import {attributeSheetState, cartState} from "../../state"
import {checkProductDiscount} from "../../utils/product"
import {FinalPrice} from "../display/final-price"
import {formatMoney} from "../display/price"
import QuantityField from "../inputQuantity"
import {ModalConfirm} from "./confirm-modal"
import {ProductPicker} from "./picker"
import {CART_ICONS} from "pages/cart/interfaces/icon"
import {useCallback, useState} from "react"
import {debounce} from "@mui/material";
import {ICON_DTP} from "../../interfaces/icon";
import {VAT_LABEL} from "../../pages/cart/interfaces/const";

export const ProductItem = ({list, product, redirectUrl = "/", mode, onDelete, ...props}) => {
   const isDiscount = checkProductDiscount(product)
   const setAttributeSheet = useSetRecoilState(attributeSheetState)

   const setCart = useSetRecoilState(cartState)
   const cart = useRecoilValue(cartState)
   const [openConfirmDeleteModal, setOpenConfirmDeleteModal] = useState(false)

   const debounceQuantityChange = useCallback(debounce((newProduct) => {
      props.updateProductOfOrder(newProduct)
   }, 1000), []) // react-hooks/exhaustive-deps
   const vatType= VAT_LABEL.find(find=> find.value == product.order_vat_rate) || VAT_LABEL[0]
   const totalPrice= (+product.price * +product.quantity)
   const vatPrice= !!vatType && +vatType.value >= 0 ?
       (+totalPrice * +product.order_vat_rate) / 100
       : 0
   const handleQuantityChange = (amount) => {
      if (amount === 0) {
         const newProduct = cart.filter((item) => item.product_id_details !== product.product_id_details)
         setCart(newProduct)
         debounceQuantityChange(newProduct)
      } else {
         const newProduct = cart.map((item) => {
            if (item.product_id_details === product.product_id_details) {
               const vatType= VAT_LABEL.find(find=> find.value == item.order_vat_rate) || VAT_LABEL[0]
               const totalPrice= amount > 9999 ? +item.quantity * +item.price : +amount * +item.price
               const vatPrice= !!vatType && +vatType.value >= 0 ?
                   (+totalPrice * +item.order_vat_rate) / 100
                   : 0
               return {
                  ...item,
                  quantity: amount > 9999 ? item.quantity : amount,
                  total_price: amount > 9999 ? +item.quantity * +item.price : +amount * +item.price,
                  order_vat_value: vatPrice,
               }
            }
            return item
         })
         setCart(newProduct)
         debounceQuantityChange(newProduct)
      }
   }

   return (
      <ProductPicker product={product}>
         {({open}) => (
            <div className="space-y-2 flex product-recommen__items">
               <Box className="product-recommen__items-img aspect-square relative">
                  <img
                     loading="lazy"
                     src={product?.image_thumb || ImgDefault}
                     style={{width: '80px', height: "80px"}}
                     className="absolute left-0 right-0 top-0 bottom-0 w-full h-full object-cover object-center rounded-lg bg-skeleton"
                  />
               </Box>
               <div className="product-recommen__items-description">
                  <div className="product-recommen__items-description___title">
                     <Text className="product-recommen__items-description___name">
                        {product?.parent_product_name}
                     </Text>
                     {mode !== "complete" && list?.length > 1 && (
                        <Text
                           className="product-recommen__items-description___delete"
                           style={{cursor: 'pointer'}}
                           onClick={() => setOpenConfirmDeleteModal(true)}
                        >
                           Xóa
                        </Text>
                     )}
                     <ModalConfirm
                        {...{
                           icon: CART_ICONS.confirmDelete,
                           title: "Xóa sản phẩm",
                           description: (
                              <>
                                 <p>Sản phẩm sau khi xoá sẽ không thể khôi phục.</p>
                                 <p>
                                    Bạn chỉ có thể thêm lại sản phẩm bằng cách bình luận từ khóa trước đó.
                                 </p>
                                 <p className="mt-3">Bạn có chắc chắn muốn thực hiện?</p>
                              </>
                           ),
                           handleConfirm: () => onDelete(product.id),
                           open: openConfirmDeleteModal,
                           onClose: () => setOpenConfirmDeleteModal(false),
                           type: "danger",
                           confirm: true,
                        }}
                     />
                  </div>
                  <div style={{minHeight: 30}}>
                     {!!product?.result_attr && product?.result_attr.length > 0 &&
                     <Text className="product-recommen__items-description___type"
                           style={{cursor: 'pointer'}}
                           data-disabled={mode === 'complete'}
                           onClick={() => setAttributeSheet({
                              display: true,
                              product: product
                           })}>
                        {product?.result_attr.map(item => item?.value).join(", ")}
                        {ICON_DTP.arrowDown}
                     </Text>}
                  </div>
                  <div className="product-recommen__items-description___price">
                     <div>
                        <Text
                            size="xxSmall"
                            className="text-gray pb-2 product-recommen__items-description___price"
                        >
                           <FinalPrice>{product}</FinalPrice>
                           {!!product?.price_discount && !!isDiscount && (
                               <Text
                                   className={`product-recommen__items-description___price-discount`}
                               >
                                  {formatMoney(product.price)}₫
                               </Text>
                           )}
                        </Text>
                        <Text as={'p'} bold>
                           {vatType.label} {vatPrice > 0 ? `(${formatMoney(vatPrice)}₫)` : ''}
                        </Text>
                     </div>
                     <Text
                        size="xxSmall"
                        className="text-gray pb-2 product-recommen__items-description___addcart"
                     >
                        {mode === "complete" ? (
                           <span className="text-[#334155] text-[15px]">{`Số lượng: ${product.quantity}`}</span>
                        ) : (
                           <QuantityField {...{
                              handleQuantityChange,
                              product,
                           }} />
                        )}
                     </Text>
                  </div>
               </div>
            </div>
         )}
      </ProductPicker>
   )
}
